import { Typography, Button, Stack, Box, Tooltip } from '@mui/material'
import { useEffect } from 'react';
import { useAuthContext } from '../../../context/AuthContext';
import QueryKey from '../../../utils/QueryKey';
import { useQuery } from 'react-query';
import { getFileUrl } from '../../../services/s3-service';
import { isNotEmpty, makeTxtOverFLow } from '../../../utils/format';
import BlurImg from '../../../components/BlurImg';
import LabelTxt from '../../../components/LabelTxt';


function ProdCardBtn({ i, mt, icon, handleProdClick, type = 'amtc' }) {
    const { setLoadingScreen, ctxtUser } = useAuthContext();
    const typoHeadStyle = { borderColor: "rgb(0,0,0,0.1)", fontSize: 11, color: "rgb(0,0,0,0.4)", display: "inline-block", width: 80 }
    const typostyle = { fontSize: 12, fontWeight: 500, color: "rgba(0,0,0, 1)", display: "inline-block" };


    const { isLoading: isImgLoading, data: imgUrl } = useQuery([QueryKey.img, i?.prodDisImg],
        () => getFileUrl({ fileKey: i?.prodDisImg }), {
        enabled: isNotEmpty(i?.prodDisImg),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    useEffect(() => {
        setLoadingScreen(isImgLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isImgLoading]);


    return (
        <>
            {/* <Stack direction={"row"} style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', }}> */}
            <Button onClick={() => handleProdClick(i)} sx={{
                padding: 1, alignItems: "center", justifyContent: "center", border: 1, borderRadius: 4, boxShadow: 1,
                borderColor: "rgba(0,0,0,0.1)", width: 190, height: 200, mt: mt ?? 1, position: "relative"
            }}>
                <Stack direction={"column"} alignItems={'center'} >
                    <Box
                        sx={{
                            width: 130,
                            height: 120,
                            borderRadius: 4,
                            my: 1,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            overflow: 'hidden', // Ensure content doesn't overflow the box
                        }}
                    >
                        <BlurImg imgUrl={imgUrl} alt={"Product"} />
                    </Box>
                    <Box sx={{ mb: 0 }}>
                        <Tooltip title={i?.prodName}>
                            <Typography sx={{ fontSize: 14, fontWeight: 500, color: "rgba(0,0,0, 1)" }} >{makeTxtOverFLow(i?.prodName.toString(), 18)}</Typography>
                        </Tooltip>
                        <LabelTxt typoname={"AMTC Ref PID"} typodetail={i?.amtcProdIdStrg} overflow={8} namestyle={typoHeadStyle} detailstyle={typostyle} />
                        {(type !== "amtc" && (isNotEmpty(i?.comId))) && <LabelTxt typoname={"Mat Code"} typodetail={i?.comProdIdStrg ?? "NA"}
                            overflow={8} namestyle={typoHeadStyle} detailstyle={typostyle} />}
                    </Box>
                </Stack>
                <Box sx={{ position: "absolute", top: 2, right: 2 }}>
                    {icon}
                </Box>

            </Button>
            {/* </Stack> */}
        </>
    )
}

export default ProdCardBtn
